__turbopack_context__.v({
  "address": "eycRUW_address",
  "component": "eycRUW_component",
  "container": "eycRUW_container",
  "logo": "eycRUW_logo",
  "menu": "eycRUW_menu",
});
